import CRUD from "@/firebase/crud";
import store from "@/store/index";
import filter from "lodash-es/filter";

const Menu = {
  namespaced: true,
  state: {
    Name: "Menu",
    Items: []
  },
  mutations: {
    setMenu(state, data) {
      state.Items = data;
    }
  },
  actions: {
    hello ({ commit }) {
      // console.log("hellllllo")
    },
    readMenu: async ({ commit }, payload) => {
      try {
        let Collection = payload[0];
        let portalID = payload[1];
        let Mutation = payload[2];
        store.commit(Mutation, []);
        let Result = Promise.resolve(
          CRUD.ReadDocuments(Collection, portalID, null)
        );
        Result.then(Response => {
          switch (Response.result) {
            case "success":
              var Data = filter(Response.data, { enabled: true });
              store.commit(Mutation, Data);
              break;
            case "failure":
              //do nothing
              break;
            case "error":
              //do nothing
              break;
            default:
              //do nothing
              break;
          }
        });
      } catch (err) {
        // console.log("menu.js >> Error = " + err);
      }
    },
    createMenuItem: async ({ commit }, payload) => {
      try {
        let Collection = payload[0];
        let Data = payload[1];
        let Mutation = payload[2];
        let Result = Promise.resolve(CRUD.CreateDocument(Collection, Data));
        Result.then(Response => {
          switch (Response.result) {
            case "success":
              store.commit(Mutation, Response.data);
              break;
            case "failure":
              // do nothing
              break;
            case "error":
              // do nothing
              break;
            default:
              // do nothing
              break;
          }
        });
      } catch (err) {
        // console.log(err);
      }
    },
    deleteMenuItem: async ({ commit }, payload) => {
      try {
        let Collection = payload[0];
        let ID = payload[1];
        let Result = Promise.resolve(CRUD.DeleteDocument(Collection, ID));
        Result.then(Response => {
          switch (Response.result) {
            case "success":
              store.commit("Menu/setMenu", Response.message);
              break;
            case "failure":
              break;
            case "error":
              break;
            default:
              break;
          }
        });
      } catch (err) {
        // console.log(err);
      }
    }
  }
}

export default Menu;
